export default __webpack_public_path__ + "static/media/eel.2377f98c.png";